// extracted by mini-css-extract-plugin
export default {"popup-header":"style_popup-header__PkP0o","spot":"style_spot__ENDfm","infoId":"style_infoId__+b0Zn"};